package com.trevorwiebe.timesheet.core.domain.model

data class OwnerOperator(
    val id: String,
    val contactName: String,
    val companyName: String = "",
    val address: String = "",
    val phone: String = "",
    val email: String = "",
    val notes: String = "",
    // Share of each load's base rate paid on settlements; null until it's been set.
    val basePayPercent: Double? = null,
    val active: Boolean = true,
    val deleted: Boolean = false,
    val order: Int = 0,
)
